import React, { Component } from "react"
import PropTypes from "prop-types"
import ItemNameCountShape from "../../state/shapes/ItemNameCountShape"
import Widget from "../layout/widget/Widget"
import { getBarChartSeriesFromItemNameCountShape } from "../../utils/widget-utils"
import BarChart from "../charts/generic/BarChart"
import ShowAllButton from "./ShowAllButton"

class NeedImproving extends Component {
  state = {
    chartIsScrollable: false
  }

  seeAllData = () => {
    this.setState({
      chartIsScrollable: !this.state.chartIsScrollable
    })
  }

  render() {
    const chartData = getBarChartSeriesFromItemNameCountShape(this.props.data)
    const { exportEndpoint, appliedFilters, subtitleKey, sampleSize } = this.props
    const titleKey="Widgets.NeedImproving.Title"
    return (
      <Widget
        columns={1}
        titleKey={titleKey}
        helpKey="Widgets.NeedImproving.Help"
        exportEndpoint={exportEndpoint}
        appliedFilters={appliedFilters}
        subtitleKey={subtitleKey}
        sampleSize={sampleSize}
      >
        <BarChart
          data={chartData}
          yAxisTitle="Widgets.NeedImproving.Responses"
          scrollbarEnabled={this.state.chartIsScrollable}
          titleKey={titleKey}
          subtitleKey={subtitleKey}
        />
        <ShowAllButton onClick={this.seeAllData} isActive={this.state.chartIsScrollable} />
      </Widget>
    )
  }
}

NeedImproving.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(ItemNameCountShape)).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string,
  sampleSize: PropTypes.object
}

export default NeedImproving



// WEBPACK FOOTER //
// ./src/components/widgets/NeedImproving.jsx